import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { language, setLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const languages = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
    { code: 'pt', label: 'PT' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-lg border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('home')}
            className="text-2xl font-bold tracking-wider hover:text-red-500 transition-colors"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            TOMÁS ROCO
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="nav-link">{t.nav.home}</button>
            <button onClick={() => scrollToSection('about')} className="nav-link">{t.nav.about}</button>
            <button onClick={() => scrollToSection('stats')} className="nav-link">{t.nav.stats}</button>
            <button onClick={() => scrollToSection('career')} className="nav-link">{t.nav.career}</button>
            <button onClick={() => scrollToSection('videos')} className="nav-link">{t.nav.videos}</button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">{t.nav.contact}</button>
          </nav>

          {/* Language Selector & Mobile Menu */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 bg-white/5 rounded-lg p-1">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => setLanguage(lang.code)}
                  className={`px-3 py-1 rounded-md text-sm font-medium transition-all ${
                    language === lang.code
                      ? 'bg-red-600 text-white'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  {lang.label}
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-white/10">
            <div className="flex flex-col space-y-3">
              <button onClick={() => scrollToSection('home')} className="nav-link-mobile">{t.nav.home}</button>
              <button onClick={() => scrollToSection('about')} className="nav-link-mobile">{t.nav.about}</button>
              <button onClick={() => scrollToSection('stats')} className="nav-link-mobile">{t.nav.stats}</button>
              <button onClick={() => scrollToSection('career')} className="nav-link-mobile">{t.nav.career}</button>
              <button onClick={() => scrollToSection('videos')} className="nav-link-mobile">{t.nav.videos}</button>
              <button onClick={() => scrollToSection('contact')} className="nav-link-mobile">{t.nav.contact}</button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
